
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34569',
  depVersions: {
  "documents-public-ui": "static-1.34569",
  "atom": "static-1.5089",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2515",
  "client-types": "static-1.467",
  "cssUtils": "static-1.797",
  "customer-data-filters-ui": "static-1.39864",
  "customer-data-objects": "static-1.7687",
  "customer-data-property-utils": "static-1.8107",
  "documents-lib": "static-1.34574",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.340",
  "FormsCommonComponents": "static-1.85910",
  "FormUrlGenerator": "static-2.4735",
  "foundations-theming-specialty": "static-1.2152",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5607",
  "hs-test-utils": "static-1.8030",
  "hub-http": "static-1.6239",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11797",
  "HubStyleTokens": "static-2.11490",
  "I18n": "static-7.1631",
  "icons": "static-2.650",
  "jasmine-immutable": "static-1.3038",
  "jasmine-runner": "static-1.6481",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7172",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5416",
  "quartz": "static-1.7054",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16689",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5356",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8187",
  "reference-resolvers-lite": "static-1.8112",
  "reporting-data": "static-1.67637",
  "reporting-reports": "static-1.67315",
  "reporting-snowflake": "static-1.56255",
  "reporting-testing-lib": "static-1.9570",
  "reporting-visualizations": "static-1.59713",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8959",
  "sanitize": "static-1.4493",
  "sanitize-text": "static-1.8158",
  "self-service-api": "static-1.10264",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1765",
  "signup-constants": "static-1.18876",
  "signup-ui-url-generator": "static-2.8069",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4778",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4779",
  "ui-addon-form-validation": "static-1.11007",
  "ui-asset-management-lib": "static-1.11061",
  "ui-images": "static-2.1159",
  "UIComponents": "static-3.8436",
  "usage-tracker": "static-1.7362",
  "usage-tracker-container": "static-1.7352",
  "usage-tracker-core": "static-1.7212",
  "viral-links-lib": "static-1.7083",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9684",
  "foundations-components": "static-1.7973",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.832",
  "quartz-core": "static-1.6273",
  "quick-fetch": "static-1.3928",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4670",
  "ui-addon-i18n": "static-1.11165",
  "ui-addon-upgrades": "static-9.18023",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3411",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3331",
  "quartz-webpack": "static-1.3278",
  "foundations-assets": "static-1.4884",
  "foundations-theming": "static-1.4436",
  "hub-http-shared-msw-handlers": "static-1.10011",
  "hubspotter-http": "static-1.4663",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.239",
  "conversations-skeleton-state": "static-1.7263",
  "crm-message-bus": "static-1.43040",
  "customer-data-filters-ui-msw-helpers": "static-1.22299",
  "customer-data-objects-ui-components": "static-1.13045",
  "customer-data-reference-ui-components": "static-1.13183",
  "customer-data-ui-utilities": "static-1.9844",
  "framework-builder-read-service-client": "static-1.4016",
  "framework-data-schema-quick-fetch": "static-1.6806",
  "framework-data-schema-resolvers": "static-1.6901",
  "inbound-db-meta-service-client": "static-1.3597",
  "inbound-db-properties-service-client": "static-1.3858",
  "multi-account-reference-resolvers": "static-1.997",
  "onboarding-tours": "static-1.16647",
  "reporting-datasets-permissions-lib": "static-1.13742",
  "ui-addon-teams": "static-1.21580",
  "quartz-auth": "static-1.729",
  "ui-business-units-lib": "static-1.9071",
  "usage-tracker-session-replay": "static-1.5048",
  "ai-components-ui-library": "static-1.9031",
  "ContentUtils": "static-1.68424",
  "customer-data-properties": "static-1.51622",
  "forms-ai-lib": "static-1.4346",
  "forms-utils-lib": "static-1.12620",
  "foundations-components-test-utils": "static-1.5456",
  "react-dnd-compat": "static-1.4631",
  "react-tinymce": "static-1.55300",
  "tinymce-config": "static-2.54426",
  "ui-gdpr-components": "static-1.10368",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3421",
  "HeadJS": "static-2.764",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3141",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.92",
  "ui-fonts": "static-1.752",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4344",
  "csstype": "static-1.50",
  "quartz-head": "static-1.719",
  "web-vitals": "static-1.6",
  "batch-promise": "static-1.1558",
  "external-options-client-types": "static-1.4170",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.729",
  "frontend-preferences-client": "static-1.7944",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3715",
  "reporting-client-types": "static-1.2500",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25440",
  "hubspot-apollo-client": "static-1.4896",
  "foundations-components-legacy": "static-1.998",
  "merchandise-lib": "static-1.264",
  "quartz-routing": "static-1.484",
  "hs-story-utils": "static-1.9441",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.244",
  "timezone-utils": "static-2.5261",
  "seat-types-lib": "static-1.54",
  "bend-plugin-foundations-components": "static-1.4242",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1999",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.729",
  "quartz-tracking": "static-1.433",
  "bend-plugin-chirp-manifest": "static-1.80",
  "chirp-fetch": "static-1.1905",
  "purchase-motions-components": "static-1.5937",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4091",
  "bender-build-tools": "static-1.3215",
  "bend-plugin-foundations-theming": "static-1.2919",
  "stylex": "static-1.33",
  "hs-resources": "static-1.171",
  "pulse": "static-1.593",
  "restore-request-side-panel-lib": "static-1.930",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3809",
  "crm-pipelines-api-client-types": "static-1.4150",
  "fdsr-migration-layer": "static-1.20",
  "multi-currency-client-types": "static-1.3702",
  "getting-started-shared-tasks": "static-1.18515",
  "growth-data-modal": "static-1.5456",
  "growth-onboarding-confetti": "static-1.3083",
  "growth-onboarding-next-action-utils": "static-1.1979",
  "navigation-components": "static-1.18097",
  "onboarding-tours-client": "static-1.4861",
  "onboarding-tours-utils": "static-1.713",
  "ui-shepherd-react": "static-3.10185",
  "ui-shepherd-tracker": "static-1.7566",
  "ui-universal-auth": "static-1.8999",
  "user-context": "static-1.5122",
  "hubspotter-http-shared-msw-handlers": "static-1.10009",
  "magpie-lib": "static-1.5561",
  "navigation-messaging": "static-1.7424",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21409",
  "copilot-toolkit": "static-1.11184",
  "cms-field-types": "static-1.4830",
  "content-icons-ui": "static-1.2232",
  "integrations-lib": "static-1.16212",
  "calling-global-api": "static-1.64581",
  "calling-internal-common": "static-1.31319",
  "calling-lifecycle-internal": "static-1.65963",
  "calling-lifecycle-messages": "static-1.58257",
  "commerce-products-lib": "static-1.9643",
  "crm-links": "static-1.6311",
  "customer-data-properties-shared-msw-handlers": "static-1.9338",
  "file-manager-components": "static-1.23678",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4235",
  "meetings-icalendar-utils-lib": "static-1.648",
  "object-builder-ui-client": "static-1.48812",
  "pipeline-validation-client-types": "static-1.3976",
  "property-value-citations": "static-1.2236",
  "smart-property-lib": "static-1.7179",
  "tiered-pricing": "static-1.1261",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9074",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19866",
  "tinymce-themes": "static-1.56396",
  "data-token-picker": "static-1.16439",
  "hub-http-contrib": "static-1.3060",
  "interframe": "static-3.4777",
  "tinymce-data": "static-1.40511",
  "tinymce-plugins": "static-1.57540",
  "ui-addon-sales-email": "static-1.5227",
  "onboarding-scopes": "static-1.6478",
  "ui-addon-opt": "static-4.8382",
  "apollo-link-hub-http": "static-2.4668",
  "hubspot-apollo-cache": "static-1.355",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.189",
  "purchase-motions-api": "static-1.5940",
  "trials-service-types": "static-1.3919",
  "bend-plugin-pulse": "static-1.96",
  "directed-graph": "static-1.953",
  "event-emitter": "static-1.964",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.1985",
  "growth-onboarding-next-action-components": "static-1.2007",
  "user-context-client": "static-1.4629",
  "idb-keyval": "static-1.44",
  "magpie-types": "static-1.5021",
  "nest": "static-1.245",
  "reactive-lib": "static-1.740",
  "simple-logging-lib": "static-1.3067",
  "unified-auth-core-lib": "static-1.795",
  "getting-started-shared-tasks-store": "static-1.17633",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13627",
  "integrations-tracking-lib": "static-1.5618",
  "native-integrations-shared-strings": "static-1.7798",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10382",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.513",
  "calling-error-reporting": "static-1.31326",
  "shared-worker-versioning": "static-1.11053",
  "calling-usage-tracker": "static-1.6559",
  "voice-sms-access-library": "static-1.1058",
  "customer-data-tracking": "static-1.6907",
  "commerce-permissions": "static-1.787",
  "products-iframe-lib": "static-1.7993",
  "products-ui-components-shared-msw-handlers": "static-1.10393",
  "location-customization-utils-lib": "static-1.9322",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4170",
  "video-components-external": "static-1.11338",
  "video-data-lib": "static-1.34996",
  "data-agent-kit": "static-1.223",
  "feedback-loader": "static-1.29330",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10094",
  "fsm": "static-1.3747",
  "policy-lib": "static-1.6794",
  "react-colorpicker": "static-2.10223",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10157",
  "FileManagerLib": "static-1.39318",
  "NamespacedHubStyle": "static-2.9070",
  "FileManagerCore": "static-1.39177",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7779",
  "layout-dnd-components": "static-1.12480",
  "layout-dnd-utils": "static-1.11455",
  "react-codemirror": "static-1.10644",
  "ui-addon-emoji-picker": "static-1.9905",
  "ui-brand-identity-lib": "static-1.15365",
  "InboxConnectUtils": "static-4.14871",
  "meetings-connect-utils-lib": "static-1.7622",
  "universal-page-editor-lib": "static-1.3030",
  "google-sheets-integration-lib": "static-1.300",
  "microsoft-drive-integration-lib": "static-1.429",
  "slack-ui-library": "static-1.10409",
  "calling-orchestration-schema": "static-1.35835",
  "sales-views-client-types": "static-1.4275",
  "crm-record-cards-service-types": "static-1.3609",
  "content-media-composition-data-lib": "static-1.12384",
  "content-media-compositions": "static-2.16391",
  "media-bridge-lib": "static-1.18958",
  "trellis-story-utils": "static-1.4533",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5941",
  "FileManagerImages": "static-1.36829",
  "video-components": "static-1.13341",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4553",
  "video-embed": "static-1.35830",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8719",
  "ui-coaching-tips": "static-1.28618",
  "ContentData": "static-1.68499",
  "layout-data-lib": "static-1.9780",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22179",
  "outpost": "static-1.4199",
  "growth-onboarding-feedback-components": "static-1.6597",
  "advanced-menus-core": "static-1.15156",
  "advanced-menus-lib": "static-1.12094",
  "ExportDialog": "static-6.10403",
  "ui-memberships-settings-lib": "static-1.34104",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15155",
  "simple-menus-lib": "static-1.16672"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34569",
  "atom": "/atom/static-1.5089",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2515",
  "client-types": "/client-types/static-1.467",
  "cssUtils": "/cssUtils/static-1.797",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39864",
  "customer-data-objects": "/customer-data-objects/static-1.7687",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8107",
  "documents-lib": "/documents-lib/static-1.34574",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.340",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85910",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4735",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2152",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5607",
  "hs-test-utils": "/hs-test-utils/static-1.8030",
  "hub-http": "/hub-http/static-1.6239",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11797",
  "HubStyleTokens": "/HubStyleTokens/static-2.11490",
  "I18n": "/I18n/static-7.1631",
  "icons": "/icons/static-2.650",
  "jasmine-immutable": "/jasmine-immutable/static-1.3038",
  "jasmine-runner": "/jasmine-runner/static-1.6481",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7172",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5416",
  "quartz": "/quartz/static-1.7054",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16689",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5356",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8187",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8112",
  "reporting-data": "/reporting-data/static-1.67637",
  "reporting-reports": "/reporting-reports/static-1.67315",
  "reporting-snowflake": "/reporting-snowflake/static-1.56255",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9570",
  "reporting-visualizations": "/reporting-visualizations/static-1.59713",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8959",
  "sanitize": "/sanitize/static-1.4493",
  "sanitize-text": "/sanitize-text/static-1.8158",
  "self-service-api": "/self-service-api/static-1.10264",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1765",
  "signup-constants": "/signup-constants/static-1.18876",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8069",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4778",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4779",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11007",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11061",
  "ui-images": "/ui-images/static-2.1159",
  "UIComponents": "/UIComponents/static-3.8436",
  "usage-tracker": "/usage-tracker/static-1.7362",
  "usage-tracker-container": "/usage-tracker-container/static-1.7352",
  "usage-tracker-core": "/usage-tracker-core/static-1.7212",
  "viral-links-lib": "/viral-links-lib/static-1.7083",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9684",
  "foundations-components": "/foundations-components/static-1.7973",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.832",
  "quartz-core": "/quartz-core/static-1.6273",
  "quick-fetch": "/quick-fetch/static-1.3928",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4670",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11165",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18023",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3411",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3331",
  "quartz-webpack": "/quartz-webpack/static-1.3278",
  "foundations-assets": "/foundations-assets/static-1.4884",
  "foundations-theming": "/foundations-theming/static-1.4436",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10011",
  "hubspotter-http": "/hubspotter-http/static-1.4663",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.239",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7263",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22299",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13045",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13183",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9844",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4016",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6806",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6901",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3597",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3858",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.997",
  "onboarding-tours": "/onboarding-tours/static-1.16647",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13742",
  "ui-addon-teams": "/ui-addon-teams/static-1.21580",
  "quartz-auth": "/quartz-auth/static-1.729",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9071",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5048",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9031",
  "ContentUtils": "/ContentUtils/static-1.68424",
  "customer-data-properties": "/customer-data-properties/static-1.51622",
  "forms-ai-lib": "/forms-ai-lib/static-1.4346",
  "forms-utils-lib": "/forms-utils-lib/static-1.12620",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5456",
  "react-dnd-compat": "/react-dnd-compat/static-1.4631",
  "react-tinymce": "/react-tinymce/static-1.55300",
  "tinymce-config": "/tinymce-config/static-2.54426",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10368",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3421",
  "HeadJS": "/HeadJS/static-2.764",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3141",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.92",
  "ui-fonts": "/ui-fonts/static-1.752",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4344",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.719",
  "web-vitals": "/web-vitals/static-1.6",
  "batch-promise": "/batch-promise/static-1.1558",
  "external-options-client-types": "/external-options-client-types/static-1.4170",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.729",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7944",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3715",
  "reporting-client-types": "/reporting-client-types/static-1.2500",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25440",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4896",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.998",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "quartz-routing": "/quartz-routing/static-1.484",
  "hs-story-utils": "/hs-story-utils/static-1.9441",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.244",
  "timezone-utils": "/timezone-utils/static-2.5261",
  "seat-types-lib": "/seat-types-lib/static-1.54",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4242",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1999",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.729",
  "quartz-tracking": "/quartz-tracking/static-1.433",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.80",
  "chirp-fetch": "/chirp-fetch/static-1.1905",
  "purchase-motions-components": "/purchase-motions-components/static-1.5937",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4091",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2919",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.171",
  "pulse": "/pulse/static-1.593",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.930",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3809",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4150",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.20",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3702",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18515",
  "growth-data-modal": "/growth-data-modal/static-1.5456",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3083",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1979",
  "navigation-components": "/navigation-components/static-1.18097",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4861",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.713",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10185",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7566",
  "ui-universal-auth": "/ui-universal-auth/static-1.8999",
  "user-context": "/user-context/static-1.5122",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10009",
  "magpie-lib": "/magpie-lib/static-1.5561",
  "navigation-messaging": "/navigation-messaging/static-1.7424",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21409",
  "copilot-toolkit": "/copilot-toolkit/static-1.11184",
  "cms-field-types": "/cms-field-types/static-1.4830",
  "content-icons-ui": "/content-icons-ui/static-1.2232",
  "integrations-lib": "/integrations-lib/static-1.16212",
  "calling-global-api": "/calling-global-api/static-1.64581",
  "calling-internal-common": "/calling-internal-common/static-1.31319",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65963",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58257",
  "commerce-products-lib": "/commerce-products-lib/static-1.9643",
  "crm-links": "/crm-links/static-1.6311",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9338",
  "file-manager-components": "/file-manager-components/static-1.23678",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4235",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.648",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48812",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3976",
  "property-value-citations": "/property-value-citations/static-1.2236",
  "smart-property-lib": "/smart-property-lib/static-1.7179",
  "tiered-pricing": "/tiered-pricing/static-1.1261",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9074",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19866",
  "tinymce-themes": "/tinymce-themes/static-1.56396",
  "data-token-picker": "/data-token-picker/static-1.16439",
  "hub-http-contrib": "/hub-http-contrib/static-1.3060",
  "interframe": "/interframe/static-3.4777",
  "tinymce-data": "/tinymce-data/static-1.40511",
  "tinymce-plugins": "/tinymce-plugins/static-1.57540",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5227",
  "onboarding-scopes": "/onboarding-scopes/static-1.6478",
  "ui-addon-opt": "/ui-addon-opt/static-4.8382",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4668",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.355",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.189",
  "purchase-motions-api": "/purchase-motions-api/static-1.5940",
  "trials-service-types": "/trials-service-types/static-1.3919",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.96",
  "directed-graph": "/directed-graph/static-1.953",
  "event-emitter": "/event-emitter/static-1.964",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1985",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2007",
  "user-context-client": "/user-context-client/static-1.4629",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-types": "/magpie-types/static-1.5021",
  "nest": "/nest/static-1.245",
  "reactive-lib": "/reactive-lib/static-1.740",
  "simple-logging-lib": "/simple-logging-lib/static-1.3067",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.795",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17633",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13627",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5618",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7798",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10382",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.513",
  "calling-error-reporting": "/calling-error-reporting/static-1.31326",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11053",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6559",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1058",
  "customer-data-tracking": "/customer-data-tracking/static-1.6907",
  "commerce-permissions": "/commerce-permissions/static-1.787",
  "products-iframe-lib": "/products-iframe-lib/static-1.7993",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10393",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9322",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4170",
  "video-components-external": "/video-components-external/static-1.11338",
  "video-data-lib": "/video-data-lib/static-1.34996",
  "data-agent-kit": "/data-agent-kit/static-1.223",
  "feedback-loader": "/feedback-loader/static-1.29330",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10094",
  "fsm": "/fsm/static-1.3747",
  "policy-lib": "/policy-lib/static-1.6794",
  "react-colorpicker": "/react-colorpicker/static-2.10223",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10157",
  "FileManagerLib": "/FileManagerLib/static-1.39318",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9070",
  "FileManagerCore": "/FileManagerCore/static-1.39177",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7779",
  "layout-dnd-components": "/layout-dnd-components/static-1.12480",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11455",
  "react-codemirror": "/react-codemirror/static-1.10644",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9905",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15365",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14871",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7622",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3030",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.300",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.429",
  "slack-ui-library": "/slack-ui-library/static-1.10409",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35835",
  "sales-views-client-types": "/sales-views-client-types/static-1.4275",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3609",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12384",
  "content-media-compositions": "/content-media-compositions/static-2.16391",
  "media-bridge-lib": "/media-bridge-lib/static-1.18958",
  "trellis-story-utils": "/trellis-story-utils/static-1.4533",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5941",
  "FileManagerImages": "/FileManagerImages/static-1.36829",
  "video-components": "/video-components/static-1.13341",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4553",
  "video-embed": "/video-embed/static-1.35830",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8719",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28618",
  "ContentData": "/ContentData/static-1.68499",
  "layout-data-lib": "/layout-data-lib/static-1.9780",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22179",
  "outpost": "/outpost/static-1.4199",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6597",
  "advanced-menus-core": "/advanced-menus-core/static-1.15156",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12094",
  "ExportDialog": "/ExportDialog/static-6.10403",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34104",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15155",
  "simple-menus-lib": "/simple-menus-lib/static-1.16672"
}
};
